
<template>
<!-- 推广用户 -->
  <div>
      <div class="table">
        <el-table
        :empty-text="$t('noData')"
        :data="tableData"
        style="width: 100%">
        <el-table-column
            width="180"
            prop="ctime"
            :label="$t('inviteTime')">
        </el-table-column>
        <el-table-column
            prop="nickname"
            :label="$t('nickname')"
           >
        </el-table-column>
        <el-table-column
            prop="mobile"
            :label="$t('mobilenumber')"
            >
        </el-table-column>
       
        </el-table>
      </div>

      <Pagination
        v-if="tableData.length>0"
        :totalPage="totalPage"
        :limit="limit"
        @changePage="handleCurrentChange"
      ></Pagination>
  </div>
</template>

<script>
import Pagination from "@/components/common/Pagination.vue";

export default {
    components: {
        Pagination
    },
    data() {
        return {
            info: {},
            userInfo: {},
            tableData: [],
            limit: 10,
            page: 1,
            totalPage: 0
        }
    },
    created() {
        this.init()
        this.tableList()
        this.$api.userInfo().then(res => {
            if(res.status) {
                this.userInfo = res.data
            }
        })
    },
    methods: {
        // 申请提现跳转
        apply() {

        },
        // 表格分页
        handleCurrentChange() {
            this.page += 1
            this.tableList()
        },
        // 推广订单数据
        tableList() {
            this.$api.recommendList({
                page: this.page,
                limit: this.limit
            }).then(res =>{
                if(res.status) {
                    this.tableData = res.data
                    this.totalPage = Math.ceil(res.count / this.limit) 
                }
            })
        },
        init() {
            this.$api.distributionCenter().then(res =>{
                if(res.status && res.data.verify == 1) {
                    this.info = res.data
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.money-pannel {
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid #ffccbc;
    border-top: 5px solid #ffccbc;
    padding: 20px 0;
    .money {
        float: left;
        width: 25%;
        border-right: 1px solid #fbe9e7;
        text-align: center;
        margin: -1px;
        font-size: 32px;
        color: #ff5722;
        cursor: pointer;
        .nums {
            font-weight: bold;
            float: none;
            margin-left: 0px;
            color: #ff5722;
            font-size: 32px;
            border: 0;
        }
        .title {
            font-weight: normal;
            font-size: 14px;
            color: #666;
            width: 100%;
            display: inline-block;
        }
        .btn {
            width: 170px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            background: #ff5722;
            color: #fff;
            display: inline-block;
            font-size: 16px;
            border-radius: 4px;
        }
    }
}
</style>